/**
 * Student Account
 * Student Account Api - Validation flow
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: dmartinez@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import SurveyQuestion from './SurveyQuestion';

/**
 * The Survey model module.
 * @module model/Survey
 * @version 1.0.0
 */
class Survey {
    /**
     * Constructs a new <code>Survey</code>.
     * A survey with questions and answers
     * @alias module:model/Survey
     */
    constructor() { 
        
        Survey.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>Survey</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Survey} obj Optional instance to populate.
     * @return {module:model/Survey} The populated <code>Survey</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new Survey();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('questions')) {
                obj['questions'] = ApiClient.convertToType(data['questions'], [SurveyQuestion]);
            }
        }
        return obj;
    }


}

/**
 * Survey identifier
 * @member {Number} id
 */
Survey.prototype['id'] = undefined;

/**
 * Survey name
 * @member {String} name
 */
Survey.prototype['name'] = undefined;

/**
 * Survey description
 * @member {String} description
 */
Survey.prototype['description'] = undefined;

/**
 * List of questions in the survey
 * @member {Array.<module:model/SurveyQuestion>} questions
 */
Survey.prototype['questions'] = undefined;






export default Survey;

